// extracted by mini-css-extract-plugin
export default {"icon":"PersonProjectRoleId-module__icon____2ukU"};